import React, { useState } from 'react'
import { checkInputs } from '../checkInputs'
import Compte from './Compte'
import { DataEntreprise } from '../interface/dataEntreprise'

const Entreprise = (): JSX.Element => {
    let [page, setPage] = useState<JSX.Element>(
        <div className="inscription" id="entreprise">
            <h1>Company</h1>

            <p>To create a professional account, complete your company information</p>

            <div id="infos">
                <input type="text" name="nom_entreprise" placeholder="Company name" required />
                <input type="text" name="siret" placeholder="Registration number" required />
                <input type="text" name="adresse" placeholder="Address" required />
                <input type="text" name="telephone" placeholder="Phone" required />
            </div>

            <button onClick={ () => {
                if (checkInputs()) {
                    let data: DataEntreprise = {
                        nomEntreprise : (document.getElementsByName("nom_entreprise")[0] as HTMLInputElement).value,
                        siret: (document.getElementsByName("siret")[0] as HTMLInputElement).value,
                        adresseEntreprise: (document.getElementsByName("adresse")[0] as HTMLInputElement).value,
                        tel: (document.getElementsByName("telephone")[0] as HTMLInputElement).value,

                        nomCompte: undefined,
                        prenom:  undefined,
                        mail: undefined,
                        mdp: undefined 
                    }
                    setPage(<Compte dataCompte={ data } />) 
                }
            } }>Confirm</button>
        </div>
    )

    return page
}

export default Entreprise